import { FC, ReactNode } from 'react';

import { Breadcrumbs, PageTitle } from '@/components';
import { breadcrumbs } from '@/constants';

import styles from './styles.module.scss';

export const MainLayout: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <div className={styles.mainLayout}>
      <Breadcrumbs crumbs={breadcrumbs} />
      <PageTitle title="Prospecting List" />
      {children}
    </div>
  );
};
